import { BaseModel } from '../../../models/base-model'
import { TestExecution } from '../test-execution'

export class TestExecutionMeta extends BaseModel {
  constructor(defaultArgs = {}) {
    super()
    this.key = defaultArgs['key'] || ''
    this.value = defaultArgs['value'] || '{}'
    this.testExecution = defaultArgs['testExecution']
  }

  public key: string
  public value: string
  public testExecution: TestExecution

  public getJsonValue(): {[key: string]: any} {
    return JSON.parse(this.value || '{}')
  }

  public setJsonValue(hash: {[key: string]: any}) {
    this.value = JSON.stringify(hash)
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/data/models/test-execution-meta/test-execution-meta.ts